export default {
  // Hero
  "pr.hero.breadcrumb_home": "Home",
  "pr.hero.breadcrumb_page": "Romanian Fishing",
  "pr.hero.title": "Romanian Fishing",
  "pr.hero.subtitle": "Tradition, identity and future — the story of professional fishermen of the Black Sea.",

  // Introductory section
  "pr.intro_title": "Romanian Fishing at the Black Sea: Between Millennia-Old Tradition and Sustainable Management",
  "pr.intro_text": "Commercial fishing along the Romanian coastline represents more than an economic activity; it is a structural component of the identity of our coastal communities. Today, practicing this profession involves a dual responsibility: preserving traditional techniques passed down from generation to generation and complying with an extremely strict European legislative framework.",
  "pr.intro_paragraph_2_before": "Over the last decades, Romanian fishing in the Black Sea has undergone significant transformations, reflecting the natural changes in the marine ecosystem, the evolution of fish resources and the permanent adaptation of fishing activity to new realities. Understanding this evolution helps us better understand the challenges and the necessary balance for this valuable resource to be exploited by future generations as well. Find ",
  "pr.intro_paragraph_2_after": " a Study analyzing the evolution of Romanian marine fisheries in the Black Sea basin between 1950 and 2023.",
  "pr.intro_old_paragraph_2": "To understand how this vital sector works, we invite you to discover the reality on the ground: from the specific regulated methods and gear for our waters, to the biology of the emblematic species of the Black Sea, whose survival is protected through strict prohibition periods and minimum catch limits.",
  "pr.intro_pdf_summary": "The study analyzes the evolution of Romanian marine fisheries in the Black Sea basin between 1950 and 2023, highlighting significant changes in fish populations, fishing fleet dynamics, and the impact of environmental and anthropogenic factors on marine resources.",
  "pr.intro_pdf_cta": "Read more",
  "pr.intro_pdf_cta_here": "here",

  // Types of fishing
  "pr.types_title": "Types of Fishing in Romania",

  "pr.type1_title": "Fishing in Internal Maritime Waters - A Millennia-Old Tradition",
  "pr.type1_text": "Black Sea fishing is part of the deep identity of communities along the Romanian coastline. From Sulina to Mangalia, generations of fishermen have lived in the rhythm of the sea, passing down techniques and knowledge for centuries. The earliest evidence of organized fishing in these lands dates back to antiquity, when Greek colonists recognized the richness of the Pontic-Danubian waters. This commercial fishing in internal maritime waters is still practiced today, with small boats up to 8m in length, motorized or not, by the artisanal fishermen of the Black Sea, a community that FOPMN protects with dedication.",

  "pr.type2_title": "Small-Scale Coastal Fishing — A Way of Life",
  "pr.type2_text": "Small-scale coastal fishing represents the backbone of Romania's fishing industry, as well as that of the EU. With small boats up to 12 m in length, covering fishing zones up to 12 nautical miles from the coast, with sea trips lasting up to 36 hours. Small-scale fishermen use traditional gear — gillnets, talians, longlines, fyke nets, dredges etc. — which minimize impact on the marine ecosystem. This form of fishing sustains entire communities and keeps the cultural heritage of the coastline alive.",

  "pr.type3_title": "Offshore Fishing",
  "pr.type3_text": "Offshore fishing (exclusive economic zone) is carried out with vessels up to 40 m in length, in zones up to 200 nautical miles from the coast, with sea trips lasting 1-7 days, with crews specialized in various activities. They use trawlers, beam trawlers, nets, longlines, dredges, traps etc., with fishing and storage capacity considerably greater than small-scale coastal fishing.",

  "pr.type4_title": "Freshwater Fishing - Tradition and Continuity",
  "pr.type4_text": "Commercial fishing in freshwater (continental) is carried out mainly in the Danube, in the Danube Branches, in inland lakes and lagoons (Lake Razim-Sinoe, lakes on the Siret and Olt rivers), as well as in the Prut River, with traditional gear adapted to fresh and brackish waters: fyke nets, gillnets, seine nets and lake nets. The main targeted species are crucian carp, bream, carp, pike, catfish, pikeperch, shad and roach. This form of fishing carried out by artisanal fishermen is inextricably linked to the traditions and ethnographic identity of local communities.",

  // Emblematic species
  "pr.species_title": "Emblematic Species of the Black Sea",
  "pr.species_text": "The Black Sea waters are home to remarkable diversity: turbot, red mullet, mullet, horse mackerel, anchovy, goby and Danube shad are just a few of the species fished by locals. Each species has its season, and professional fishermen respect quotas and prohibition periods to ensure stock regeneration.",

  // CTA
  "pr.cta_title": "Support Romanian Fishing",
  "pr.cta_text": "FOPMN fights daily for the rights of professional fishermen. Join our community or contact us for more information.",
  "pr.cta_contact": "Contact Us",
  "pr.cta_about": "About FOPMN",

  // ── SpeciesSection UI ──────────────────────────────────────────────────────
  "pr.spec.section_label": "Black Sea Species",
  "pr.spec.section_title": "Commercial Species - Minimum Legal Sizes & Prohibition Periods",
  "pr.spec.section_subtitle": "According to Order no. 23/297/2025 (MADR & MMAP), published in the Official Gazette no. 95/01.02.2025. Marine species are permitted year-round, except for turbot, dogfish, gobiids and sturgeons. Data updated 2025 — verify ANPA updates annually.",
  "pr.spec.section_fao_description": "The 3-letter FAO code for species (also called the ASFIS Code) is mandatory from catch to market, being used in vessels' electronic logbooks, in official landing documents and sales notes, in EU lot traceability and commercial documents, as well as in global statistical reports submitted to Eurostat and FAO.",
  "pr.spec.filter_all": "All",
  "pr.spec.filter_pelagic": "Pelagic",
  "pr.spec.filter_demersal": "Demersal",
  "pr.spec.filter_costier": "Coastal",
  "pr.spec.filter_nevertebrate": "Invertebrates",
  "pr.spec.filter_interzis": "Prohibited",
  "pr.spec.search_placeholder": "Search species...",
  "pr.spec.legend_prohibition": "Prohibition month",
  "pr.spec.legend_permitted": "Fishing permitted",
  "pr.spec.legend_banned": "Permanently banned",
  "pr.spec.field_dim_min": "Min. size",
  "pr.spec.field_prohibition": "Prohibition",
  "pr.spec.field_calendar": "Annual calendar",
  "pr.spec.field_gear": "Permitted gear",
  "pr.spec.badge_banned": "Catch Prohibited",
  "pr.spec.badge_venomous": "VENOMOUS - DO NOT TOUCH",
  "pr.spec.badge_vulnerable": "VULNERABLE",
  "pr.spec.badge_priority": "Priority",
  "pr.spec.not_found": "No species found for",
  "pr.spec.pdf_button": "All Black Sea fish species",
  "pr.spec.calcan_link": "Dedicated page — Complete factsheet, ANPA Quotas",

  // ── Species data ───────────────────────────────────────────────────────────
  "pr.spec.item_1_name": "Turbot",
  "pr.spec.item_1_prohibitionText": "April 15 – June 15",
  "pr.spec.item_1_notes": "The species with the highest commercial value in the Black Sea. Prohibition Apr 15–Jun 15 (Ord. 23/297/2025 Art. 1). Minimum size 45 cm (total length). Gillnets with mesh ≥ 400 mm.",

  "pr.spec.item_2_name": "Anchovy",
  "pr.spec.item_2_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_2_notes": "The dominant pelagic species. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1 para. (1).",

  "pr.spec.item_3_name": "Sprat",
  "pr.spec.item_3_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_3_notes": "Mostly caught at night using attraction lights. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_4_name": "Mullet",
  "pr.spec.item_4_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_4_notes": "General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1. EU Reg. 1343/2011.",

  "pr.spec.item_5_name": "Horse Mackerel",
  "pr.spec.item_5_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_5_notes": "Abundant and widely consumed species. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_28_name": "Sand Smelt",
  "pr.spec.item_28_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_28_notes": "Small pelagic species, endemic to the Black Sea and Mediterranean. Lives in schools in shallow coastal areas. Sold locally fried or marinated. General prohibition Apr 9–Jun 7.",

  "pr.spec.item_6_name": "Flounder",
  "pr.spec.item_6_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_6_notes": "General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_25_name": "Sole",
  "pr.spec.item_25_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_25_notes": "Demersal species with asymmetrical body, both eyes on the right side. Lives on sandy bottoms. General prohibition Apr 9–Jun 7.",

  "pr.spec.item_7_name": "Bluefish",
  "pr.spec.item_7_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_7_notes": "Pelagic predator present in the Black Sea during the warm season. High commercial value, firm white flesh. General prohibition Apr 9–Jun 7.",

  "pr.spec.item_8_name": "Round Goby",
  "pr.spec.item_8_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_8_notes": "Species from the Gobiidae family. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1. Sold locally.",

  "pr.spec.item_9_name": "Red Mullet",
  "pr.spec.item_9_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_9_notes": "Demersal species with high commercial value. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_10_name": "Toad Goby",
  "pr.spec.item_10_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_10_notes": "Species from the Gobiidae family. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_11_name": "Danube Shad",
  "pr.spec.item_11_prohibitionText": "April 9 – June 7 (60 days) + specific Danube prohibition",
  "pr.spec.item_11_notes": "Anadromous migratory species. General prohibition Apr 9–Jun 7 (60 days) + specific prohibition on Danube sectors according to Ord. 23/297/2025. Banned in front of Danube mouths year-round (5 km offshore, 2 km corridor).",
  "pr.spec.item_11_secondary_name": "Allis Shad (ASD)",

  "pr.spec.item_12_name": "Garfish",
  "pr.spec.item_12_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_12_notes": "Elongated pelagic fish with green-colored bones (harmless natural feature). General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025.",

  "pr.spec.item_13_name": "Common Stingray",
  "pr.spec.item_13_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_13_notes": "Ray species with venomous spine on the tail. Handle with extreme caution. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025.",

  "pr.spec.item_14_name": "Thornback Ray",
  "pr.spec.item_14_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_14_notes": "Skate species with characteristic spines. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025.",

  "pr.spec.item_16_name": "Azov Shad",
  "pr.spec.item_16_prohibitionText": "April 9 – June 7 (60 days) + specific Danube prohibition",
  "pr.spec.item_16_notes": "Anadromous species related to shad. General prohibition Apr 9–Jun 7 (60 days) + specific prohibition on Danube sectors according to Ord. 23/297/2025.",

  "pr.spec.item_17_name": "Black Sea Sprat",
  "pr.spec.item_17_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_17_notes": "Endemic Black Sea-Caspian species, very small. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_18_name": "Tub Gurnard",
  "pr.spec.item_18_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_18_notes": "Demersal species from the Triglidae family. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025. White, fine flesh appreciated in gastronomy.",

  "pr.spec.item_19_name": "Whiting",
  "pr.spec.item_19_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_19_notes": "Endemic subspecies of the Black Sea. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025.",

  "pr.spec.item_20_name": "Spiny Dogfish",
  "pr.spec.item_20_prohibitionText": "Apr 9–Jun 7 (60 days) + Oct 15–Nov 30",
  "pr.spec.item_20_notes": "General prohibition Apr 9–Jun 7 (60 days) + specific prohibition Oct 15–Nov 30 according to Ord. 23/297/2025. Pregnant females banned year-round.",

  "pr.spec.item_26_name": "Atlantic Bonito",
  "pr.spec.item_26_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_26_notes": "Fast pelagic predator species. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025 Art. 1.",

  "pr.spec.item_27_name": "European Seabass",
  "pr.spec.item_27_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_27_notes": "Extremely valuable commercial coastal species. General prohibition Apr 9–Jun 7 according to Ord. 23/297/2025. White, fine flesh.",

  "pr.spec.item_15_name": "Rapa Whelk",
  "pr.spec.item_15_prohibitionText": "No prohibition – permitted year-round",
  "pr.spec.item_15_notes": "Rapa whelk harvesting is permitted year-round according to Ord. 23/297/2025 Art. 6 para. (7). Express exception from the general 60-day prohibition. Invasive species accidentally introduced from the Pacific.",

  "pr.spec.item_21_name": "Mussel",
  "pr.spec.item_21_prohibitionText": "No prohibition – permitted year-round",
  "pr.spec.item_21_notes": "Permitted year-round, including during Apr 9–Jun 7 (invertebrate exception). Marketing conditional on marine biotoxin analysis (DSP, ASP, PSP) performed by DSVSA.",

  "pr.spec.item_22_name": "Sturgeons",
  "pr.spec.item_22_prohibitionText": "TOTALLY PROHIBITED – year-round",
  "pr.spec.item_22_notes": "Fishing of all sturgeon species is prohibited year-round, except for scientific research purposes. Any capture, possession, transport or sale constitutes a criminal offense.",

  "pr.spec.item_24_name": "Greater Weever",
  "pr.spec.item_24_prohibitionText": "April 9 – June 7 (60 days)",
  "pr.spec.item_24_notes": "Venomous demersal species. Venomous dorsal and opercular spines cause painful wounds. General prohibition Apr 9–Jun 7. In case of sting, seek immediate medical attention.",

  // ── GearSection UI ─────────────────────────────────────────────────────────
  "pr.gear.section_title": "Main Fishing Gear Used",
  "pr.gear.section_subtitle": "Overview of the main commercial fishing gear used in Romania, authorized under current Romanian and European legislation. Gear must comply with minimum dimensions in Annex IX of Reg. 1241/2019 (e.g.: 400 mm for turbot gillnets). Any unmarked gear or gear not meeting technical standards results in immediate revocation of the fishing license. Conflict with non-EU states: Regulation 1241/2019 applies only to EU vessels (Romania, Bulgaria). Vessels from Turkey, Ukraine, Russia or Georgia operate under different standards, creating a competitive and biological imbalance.",
  "pr.gear.section_fao_description": "The FAO codes (in parentheses) are used globally in electronic logbooks, in fishing reports and by control authorities (including in the European Union) to monitor the impact of each technique on the marine ecosystem.",
  "pr.gear.filter_all": "All",
  "pr.gear.filter_passive": "Passive",
  "pr.gear.filter_active": "Active",
  "pr.gear.badge_passive": "Passive",
  "pr.gear.badge_active": "Active",
  "pr.gear.reg_label": "Regulation:",

  // ── Gear items ─────────────────────────────────────────────────────────────
  "pr.gear.item_0_name": "Manual Harvesting",
  "pr.gear.item_0_description": "Manual harvesting of mollusks by divers in shallow coastal waters, using mesh baskets and lifting them onto the vessel deck. This is an extremely selective fishing method (completely eliminating bycatch or undersized catches), used in Romania for rapa whelks and mussels.",
  "pr.gear.item_0_bullet_0_label": "Method",
  "pr.gear.item_0_bullet_0_value": "manual diving with scuba equipment",
  "pr.gear.item_0_bullet_1_label": "Working depth",
  "pr.gear.item_0_bullet_1_value": "0 – 20 m",
  "pr.gear.item_0_bullet_2_label": "Selectivity",
  "pr.gear.item_0_bullet_2_value": "100% – no bycatch",
  "pr.gear.item_0_bullet_3_label": "Target species",
  "pr.gear.item_0_bullet_3_value": "rapa whelk (Rapana venosa), mussels (Mytilus galloprovincialis)",
  "pr.gear.item_0_bullet_4_label": "Equipment",
  "pr.gear.item_0_bullet_4_value": "mesh baskets, diving equipment",
  "pr.gear.item_0_bullet_5_label": "Seabed impact",
  "pr.gear.item_0_bullet_5_value": "minimal – no contact with substrate",
  "pr.gear.item_0_regulations": "Activity permitted under individual fishing license. Divers must hold professional diving certification. Minimum catches: rapa whelk ≥60 mm, mussel ≥50 mm.",

  "pr.gear.item_1_name": "Gillnets",
  "pr.gear.item_1_description": "Fixed or drifting nets used to catch fish by entangling them in the mesh. Ideal for demersal and pelagic species in the Black Sea: mullet, shad, flounder, turbot.",
  "pr.gear.item_1_bullet_0_label": "Net length",
  "pr.gear.item_1_bullet_0_value": "25 – 200 m",
  "pr.gear.item_1_bullet_1_label": "Net height",
  "pr.gear.item_1_bullet_1_value": "1.5 – 8 m",
  "pr.gear.item_1_bullet_2_label": "Mesh size",
  "pr.gear.item_1_bullet_2_value": "28 – 160 mm (depending on species)",
  "pr.gear.item_1_bullet_3_label": "Material",
  "pr.gear.item_1_bullet_3_value": "PA monofilament or multifilament",
  "pr.gear.item_1_bullet_4_label": "Max working depth",
  "pr.gear.item_1_bullet_4_value": "60 m",
  "pr.gear.item_1_bullet_5_label": "Gear autonomy",
  "pr.gear.item_1_bullet_5_value": "6 – 18 hours",
  "pr.gear.item_1_regulations": "According to EU Reg. 1343/2011 – use prohibited at distances <3 Nm from the coast during prohibition periods.",

  "pr.gear.item_2_name": "Talian (Trap Net)",
  "pr.gear.item_2_description": "Marine talians are large-scale trap-type fishing gear, deployed at depths of 5–12 m. In marine talians, the retaining chambers are installed parallel to the shore, reaching up to 70 m in length, with fish guidance provided by net wings of 300–500 m. The functional shape is maintained with floats or wooden poles.",
  "pr.gear.item_2_bullet_0_label": "Gear type",
  "pr.gear.item_2_bullet_0_value": "large fixed trap",
  "pr.gear.item_2_bullet_1_label": "Working depth",
  "pr.gear.item_2_bullet_1_value": "5 – 12 m",
  "pr.gear.item_2_bullet_2_label": "Chamber orientation",
  "pr.gear.item_2_bullet_2_value": "parallel to shore",
  "pr.gear.item_2_bullet_3_label": "Retaining chamber length",
  "pr.gear.item_2_bullet_3_value": "up to 70 m",
  "pr.gear.item_2_bullet_4_label": "Guide wing length",
  "pr.gear.item_2_bullet_4_value": "300 – 500 m",
  "pr.gear.item_2_bullet_5_label": "Target species",
  "pr.gear.item_2_bullet_5_value": "sprat, anchovy, red mullet, bluefish, horse mackerel",
  "pr.gear.item_2_regulations": "Talian placement is done according to individual fishing license. GPS position reporting to ANPA is mandatory.",

  "pr.gear.item_3_name": "Longlines",
  "pr.gear.item_3_description": "Linear gear with individual baited hooks mounted on secondary snoods. Used for deep-water predatory fish: turbot, Black Sea dogfish, European seabass.",
  "pr.gear.item_3_bullet_0_label": "Number of hooks",
  "pr.gear.item_3_bullet_0_value": "100 – 1,500 hooks/longline",
  "pr.gear.item_3_bullet_1_label": "Distance between hooks",
  "pr.gear.item_3_bullet_1_value": "0.5 – 2 m",
  "pr.gear.item_3_bullet_2_label": "Mainline diameter",
  "pr.gear.item_3_bullet_2_value": "1.5 – 3 mm",
  "pr.gear.item_3_bullet_3_label": "Snood diameter",
  "pr.gear.item_3_bullet_3_value": "0.6 – 1 mm",
  "pr.gear.item_3_bullet_4_label": "Working depth",
  "pr.gear.item_3_bullet_4_value": "bottom (5 – 100 m)",
  "pr.gear.item_3_bullet_5_label": "Fishing time",
  "pr.gear.item_3_bullet_5_value": "2 – 12 hours",
  "pr.gear.item_3_regulations": "Permitted in accordance with MADR Order no. 464/2021. Total ban for beluga and sturgeons.",

  "pr.gear.item_4_name": "Fyke Nets and Traps",
  "pr.gear.item_4_description": "Fixed traps of cylindrical, conical or rectangular shape, with directed entrances preventing fish escape. High selectivity, reduced impact on the seabed. Used for: goby, toad goby, rapa whelk, crustaceans etc.",
  "pr.gear.item_4_bullet_0_label": "Fyke net length",
  "pr.gear.item_4_bullet_0_value": "2 – 6 m",
  "pr.gear.item_4_bullet_1_label": "Hoop diameter",
  "pr.gear.item_4_bullet_1_value": "40 – 90 cm",
  "pr.gear.item_4_bullet_2_label": "Net material",
  "pr.gear.item_4_bullet_2_value": "PA monofilament",
  "pr.gear.item_4_bullet_3_label": "Number of chambers",
  "pr.gear.item_4_bullet_3_value": "2 – 5",
  "pr.gear.item_4_bullet_4_label": "Anchoring",
  "pr.gear.item_4_bullet_4_value": "concrete or metal weights",
  "pr.gear.item_4_bullet_5_label": "Inspection interval",
  "pr.gear.item_4_bullet_5_value": "24 – 72 hours",
  "pr.gear.item_4_regulations": "Authorized under individual fishing license; mandatory GPS/light beacon marking.",

  "pr.gear.item_45_name": "Dredges",
  "pr.gear.item_45_description": "The towed shellfish dredge is a rigid steel structure equipped with a lower blade that cuts the byssus threads of colonies and a metal ring mesh bag that mechanically sorts catches directly on the substrate. The hydraulic dredge (hydro rake) uses special nozzles connected to a high-pressure pump to fluidize the substrate with water jets, detaching bivalves through hydraulic impact before they are pushed directly into the collection bag. Both are harvesting tools for: mussels, clams.",
  "pr.gear.item_45_bullet_0_label": "Gear type",
  "pr.gear.item_45_bullet_0_value": "mechanical dredge / hydraulic dredge",
  "pr.gear.item_45_bullet_1_label": "Working method",
  "pr.gear.item_45_bullet_1_value": "substrate towing / high-pressure hydraulic jet",
  "pr.gear.item_45_bullet_2_label": "Working depth",
  "pr.gear.item_45_bullet_2_value": "2 – 25 m",
  "pr.gear.item_45_bullet_3_label": "Metal bag length",
  "pr.gear.item_45_bullet_3_value": "1.5 – 4 m",
  "pr.gear.item_45_bullet_4_label": "Target species",
  "pr.gear.item_45_bullet_4_value": "mussels (Mytilus galloprovincialis), clams (Ruditapes decussatus)",
  "pr.gear.item_45_bullet_5_label": "Handling",
  "pr.gear.item_45_bullet_5_value": "hydraulic or electric winch onboard",
  "pr.gear.item_45_regulations": "Activity permitted under commercial fishing license and bivalve stock management plan. Mandatory catch reporting to ANPA. Harvesting zones are established by annual permit.",

  "pr.gear.item_5_name": "Bottom Trawl (BeamTrawl)",
  "pr.gear.item_5_description": "The trawl is a large bag-shaped net towed by a vessel. In Romania, the only permitted bottom trawl is exclusively for harvesting rapa whelks. Handling with hydraulic or electric winch onboard.",
  "pr.gear.item_5_bullet_0_label": "Gear type",
  "pr.gear.item_5_bullet_0_value": "towed bag net",
  "pr.gear.item_5_bullet_1_label": "Bag length",
  "pr.gear.item_5_bullet_1_value": "8 – 20 m",
  "pr.gear.item_5_bullet_2_label": "Horizontal opening",
  "pr.gear.item_5_bullet_2_value": "4 – 12 m",
  "pr.gear.item_5_bullet_3_label": "Trawling speed",
  "pr.gear.item_5_bullet_3_value": "2 – 3.5 knots",
  "pr.gear.item_5_bullet_4_label": "Max depth",
  "pr.gear.item_5_bullet_4_value": "80 m",
  "pr.gear.item_5_bullet_5_label": "Permitted species",
  "pr.gear.item_5_bullet_5_value": "exclusively rapa whelk (Rapana venosa)",
  "pr.gear.item_5_regulations": "In Romania, bottom trawling is permitted exclusively for rapa whelk harvesting. Prohibited at <3 Nm from the coast and in the Danube Delta Biosphere Reserve area.",

  "pr.gear.item_6_name": "Pelagic Trawl",
  "pr.gear.item_6_description": "The pelagic or semi-pelagic trawl is a very large bag-shaped net, spread horizontally at its mouth by a set of pelagic trawl doors, towed by a vessel/ship in the water column without touching the seabed. Handling with hydraulic or electric winch onboard. Suitable for schooling species: sprat, anchovy, horse mackerel etc.",
  "pr.gear.item_6_bullet_0_label": "Gear type",
  "pr.gear.item_6_bullet_0_value": "towed pelagic bag net",
  "pr.gear.item_6_bullet_1_label": "Net length",
  "pr.gear.item_6_bullet_1_value": "80 – 400 m",
  "pr.gear.item_6_bullet_2_label": "Vertical opening",
  "pr.gear.item_6_bullet_2_value": "20 – 80 m",
  "pr.gear.item_6_bullet_3_label": "Trawling speed",
  "pr.gear.item_6_bullet_3_value": "3 – 5 knots",
  "pr.gear.item_6_bullet_4_label": "Working depth",
  "pr.gear.item_6_bullet_4_value": "10 – 400 m (water column)",
  "pr.gear.item_6_bullet_5_label": "Target species",
  "pr.gear.item_6_bullet_5_value": "sprat, anchovy, horse mackerel",
  "pr.gear.item_6_regulations": "Permitted under EU Reg. 1343/2011. Mandatory selectivity devices (sorting grids). Electronic catch reporting via VMS/ERS system.",

  "pr.gear.item_7_name": "Purse Seine",
  "pr.gear.item_7_description": "Nocturnal or diurnal pelagic fishing using underwater lights to attract fish, followed by encircling the school with a very wide circular net, subsequently pursed like a bag, from which the caught fish is extracted and stored onboard. Optimal for sprat, anchovy and horse mackerel.",
  "pr.gear.item_7_bullet_0_label": "Net length",
  "pr.gear.item_7_bullet_0_value": "200 – 600 m",
  "pr.gear.item_7_bullet_1_label": "Net height",
  "pr.gear.item_7_bullet_1_value": "30 – 80 m",
  "pr.gear.item_7_bullet_2_label": "Lamp power",
  "pr.gear.item_7_bullet_2_value": "2,000 – 10,000 W",
  "pr.gear.item_7_bullet_3_label": "Number of lamps",
  "pr.gear.item_7_bullet_3_value": "4 – 12 units",
  "pr.gear.item_7_bullet_4_label": "School attraction time",
  "pr.gear.item_7_bullet_4_value": "1 – 3 hours",
  "pr.gear.item_7_bullet_5_label": "Catch capacity/haul",
  "pr.gear.item_7_bullet_5_value": "100 – 5,000 kg",
  "pr.gear.item_7_regulations": "Use of attraction lamps is permitted only with special ANPA authorization. Prohibited at <1 Nm from other vessels.",

  "pr.gear.item_8_name": "Rods and Lines",
  "pr.gear.item_8_description": "Active fishing with automatic or manual rods, using articulated spoons or acrylic jigs. Used for European seabass, Atlantic bonito, turbot and other carnivorous species. Maximum selectivity, zero bycatch.",
  "pr.gear.item_8_bullet_0_label": "Hooks per gear",
  "pr.gear.item_8_bullet_0_value": "3 – 20",
  "pr.gear.item_8_bullet_1_label": "Sinker weight",
  "pr.gear.item_8_bullet_1_value": "100 – 600 g",
  "pr.gear.item_8_bullet_2_label": "Working depth",
  "pr.gear.item_8_bullet_2_value": "10 – 80 m",
  "pr.gear.item_8_bullet_3_label": "Action type",
  "pr.gear.item_8_bullet_3_value": "manual or electric (220 V / DC)",
  "pr.gear.item_8_bullet_4_label": "Bait type",
  "pr.gear.item_8_bullet_4_value": "artificial or natural",
  "pr.gear.item_8_bullet_5_label": "Selective catch",
  "pr.gear.item_8_bullet_5_value": "100% target species",
  "pr.gear.item_8_regulations": "No special restrictions. Minimum catch sizes per species must be observed (EU Reg. 1343/2011, Annex III).",
};